import styled from 'styled-components';
export const PageTitle = styled.h2`
  margin: 18px 0 16px 27px;
  font-size: 20px;
  font-family: 'OpenSans-SemiBold';
  font-weight: 600;
  color: #292929;
`;
export default {
  PageTitle
};